// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-form ol,
.p-form  ul {
  list-style: none;
  list-style-type: none;
}

.p-form a {
  color: inherit;
  text-decoration: none;
}

.p-form img {
  height: auto;
  max-width: 100%;
  vertical-align: top;
}

.p-form table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}

.p-form input,
.p-form button,
.p-form textarea,
.p-form select {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-radius: 0;
  font-family: inherit;
}

.p-form input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #757575;
}

.p-form input::-moz-placeholder,
textarea::-moz-placeholder {
  color: #757575;
}

.p-form input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  color: #757575;
}

.p-form input::-ms-input-placeholder,
textarea::-ms-input-placeholder {
  color: #757575;
}

.p-form input::placeholder,
textarea::placeholder {
  color: #757575;
}

.p-form input[type=submit],
.p-form button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  cursor: pointer;
  outline: none;  
  align-items: center;
  background: #2a3d86;
  background: linear-gradient(90deg, #2a3d86, #5a5fd9);
  color: #fff;
  display: flex;
  font-size: 1.6rem;
  font-family: serif;
  font-weight: 700;
  height: 5rem;
  justify-content: center;
  margin: 2.5rem auto 0;
  border-radius: 2.5rem;
  max-width: 40rem;
  opacity: 1;
  width: 100%;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.p-form__item:not(:first-child) {
  margin-top: 2.5rem;
}

.p-form__head {
  font-family: serif;
  font-weight: 700;
  padding-bottom: 0.5rem;
}

.p-form__body {
  font-size: 1.2rem;
}

.p-form__body input,
.p-form__body select {
  background: #f5f5f5;
  border: none;
  border-radius: 0;
  box-shadow: none;
  box-sizing: border-box;
  font-family: inherit;
  font-size: 1.2rem;
  padding: 1rem 1rem;
}

.p-form__body textarea {
  background: #f5f5f5;
  border: none;
  border-radius: 0;
  box-shadow: none;
  box-sizing: border-box;
  font-family: inherit;
  font-size: 1.2rem;
  padding: 1rem 1rem;
  width: 100%;
}

.p-form__body select:disabled {
  color: #8f8f8f;
}

.p-form__body {
  position: relative;
}

.p-form__body input[type=text],
.p-form__body input[type=tel],
.p-form__body input[type=email],
.p-form__body input[type=textarea],
.p-form__body select {
  width: 100%;
  max-width: 100%;
}


.p-form__mb {
  margin-bottom: 1rem;
}

.p-form__form-area {
  position: relative;
}

.p-form__form-area--devide {
  width: calc(50% - 0.5rem);
}

.p-form__form-area--devide:last-child {
  margin-left: 1rem;
}

.p-form__required, .any {
  bottom: 1.6rem;
  color: #fff;
  display: inline-block;
  font-size: 1rem;
  font-weight: 500;
  height: 1.6rem;
  line-height: 1;
  line-height: 1.4rem;
  margin-left: 1rem;
  text-align: center;
  width: 3.7rem;
  background-color: #ff9b15;
  vertical-align: middle;
}

.p-form__privacy {
  margin-top: 5rem;
  display: flex; /* フレックスボックスで横並びにする */
  align-items: center; /* チェックボックスとテキストを縦方向に中央揃え */
  justify-content: center; /* チェックボックスとテキストを左揃え */
  text-align: center; /* テキストを左揃え */
}

.p-form__privacy-check {
  width: 2rem;
  height: 2rem;
  margin-right: 1rem;
  appearance: none;
  border: 0.1rem solid #2a3d86;
  border-radius: 0.2rem;
  position: relative;
  background-color: #ffffff;
}

.p-form__privacy-check:checked {
  background-color: #2a3d86; /* チェック時の背景色 */
  border-color: #2a3d86; /* チェック時の枠線の色 */
}

.p-form__privacy-check:checked::after {
  content: '';
  position: absolute;
  top: 0.3rem;
  left: 0.6rem;
  width: 0.6rem;
  height: 1.2rem;
  border: solid white;
  border-width: 0 0.2rem 0.2rem 0;
  transform: rotate(45deg);
}

.p-form__privacy-label {
  font-size: 1.4rem;
  font-family: serif;
  cursor: pointer;
  display: inline-block; /* ラベルをインラインブロックに */
  margin-right: 1rem; /* テキストとリンクの間にスペースを追加 */
}

.p-form__privacy-link {
  display: block; /* リンクを別の行に表示 */
  text-align: center; /* リンクを中央揃え */
  color: blue !important;
  text-decoration: underline;
  margin-top: 0.5rem; /* ラベルとリンクの間にスペースを追加 */
}

.p-form__privacy-error {
  display: block; /* リンクを別の行に表示 */
  align-items: center; /* チェックボックスとテキストを縦方向に中央揃え */
  justify-content: center; /* チェックボックスとテキストを左揃え */
  text-align: center; /* リンクを中央揃え */
  margin-top: 0.5rem; /* ラベルとリンクの間にスペースを追加 */
}

.p-form__notice {
  font-size: 1.4rem !important;
}


.p-form__send {
  align-items: center;
  background: linear-gradient(90deg, #2a3d86, #5a5fd9); /* グラデーションを適用 */
  color: #fff;
  display: flex;
  font-size: 1.8rem;
  font-weight: 700;
  height: 5rem;
  justify-content: center;
  margin: 3rem auto 0;
  max-width: 40rem;
  border: none;
  border-radius: 2.5rem; /* 丸みを追加 */
  width: 100%;
  transition: all 0.3s ease; /* スムーズなトランジションを追加 */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* ボックスシャドウを追加 */
  cursor: pointer;
}

.p-form__send:hover {
  background: linear-gradient(90deg, #5a5fd9, #2a3d86); /* ホバー時のグラデーション反転 */
  transform: translateY(-3px); /* ホバー時に少し浮かせる */
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2); /* シャドウを強調 */
}

.p-form__send:active {
  transform: translateY(0); /* クリック時に戻す */
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1); /* クリック時のシャドウを弱める */
}


.p-form__send.is_checked {
  opacity: 1;
}

.p-form__two-columns {
  display: flex;
  gap: 1rem;
  flex-wrap: nowrap;
}

.p-form__input-wrapper {
  position: relative;
  width: 100%;
}


.p-form__two-columns input,
.p-form__two-columns select {
  width: 100%;
}
.p-form__margin-bottom {
  margin-bottom: 0.5rem;
}

.p-form__subtext {
  font-size: 1rem;
  color: #757575;
  margin-top: 0.2rem;
}

/* 警告メッセージ表示用 */
.error.warning {
  display: block;
  color: #FB3640;
  font-size: 1.2rem;
  margin-top: 0.5rem;
}

/** alert **/
.alert {
  font-size: 1rem;
  color: #FB3640;
}

.notfilled {
  font-size: 1.2rem;
  color: #fff;
  background-color: #FB3640;
  text-align: center;
}


.notfilled.invalid {
  background-color: #FB3640;
  color: white;
}

.recaptcha-error {
  color: #FB3640;
  font-size: 1.2rem;
  text-align: center;
}

/* 未記入項目がある場合のエラースタイル */
.invalid input,
.invalid select,
.invalid textarea {
  border: 0.1rem solid #FB3640;
  background-color: #ffe1e1;
}

.error {
  color: #FB3640;
  font-size: 1.2rem;
  display: none;
}


.error.invalid {
  display: block;
  color: #FB3640;
  font-size: 1.2rem;
  margin-top: 0.5rem; /* エラーメッセージと他の要素の間にスペースを追加 */
}




@media only screen and (min-width: 768px) {
  .p-form__head {
    font-size: 1.2rem;
  }
  .p-form__item {
    border-top: 0.1rem solid #e5e5e5;
    display: flex;
    margin-top: 0;
    margin-bottom: 0;
    padding: 0.5rem 0;
  }

  .p-form__item--bottom {
    display: flex;
    margin-top: 0;
    margin-bottom: 0;
    padding: 0 0 1rem 0;
  }

  .p-form__item:not(:first-child) {
    margin-top: 0;
  }

  .p-form__head {
      -webkit-transform: translateY(0.5rem);
      transform: translateY(0.5rem);
      width: 30%;
  }
  
  .p-form__item:not(:first-child) {
    margin-top: 0;
  }
  
  .p-form__body {
    width: 70%;
  }
  
  .p-form__body input,
  .p-form__body textarea,
  .p-form__body select {
    font-size: 1.2rem;
    padding-bottom: 1.8rem;
    padding-top: 1.8rem;
  }
  
  .p-form__form-area--devide {
    width: calc(50% - 1rem);
  }
  
  .p-form__form-area--devide:last-child {
    margin-left: 2rem;
  }
  
  .p-form__required {
    font-size: 1.2rem;
    font-family: sans-serif;
  }
  
  .p-form__send {
    font-size: 1.6rem;
    height: 7.4rem;
    margin-top: 5rem;
  }
}
.g-recaptcha {
  margin-right: auto;
  margin-left: auto;
  text-align: center;
  width: 30rem;
  margin-top: 2rem;
}

.loader {
  border: 0.6rem solid #f3f3f3; /* Light grey */
  border-top: 0.6rem solid #2a3d86; /* Blue */
  border-radius: 50%;
  width: 5rem;
  height: 5rem;
  animation: spin 1s linear infinite;
}

.p-form__send.is-submitting {
  background-color: #d3d3d3; /* 処理中の背景色 */
  cursor: not-allowed;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

#loadingIndicator {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000; /* Ensure it's above other content */
}

/* ローディングスピナー */
.loading-spinner {
  width: 20px;
  height: 20px;
  border: 3px solid #f3f3f3; /* 背景色 */
  border-top: 3px solid #3498db; /* スピナーの色 */
  border-radius: 50%;
  animation: spin 1s linear infinite;
  display: inline-block;
}

/* スピナーのアニメーション */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* ボタンが処理中のスタイル */
.p-form__send.is-submitting {
  cursor: not-allowed;
  opacity: 0.8;
}

/* 画面全体を覆うオーバーレイ */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明の背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}


 /* モバイル用メディアクエリ */
 @media (max-width: 767px) {
  .p-form__head {
    font-size: 1.2rem;
  }

  .p-form__item:not(:first-child) {
    margin-top: 1rem;
  }
  .p-form__privacy {
    margin-top: 2rem;
  }

  .p-form__two-columns {
    display: flex;
    flex-wrap: nowrap;
    gap: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Form.css"],"names":[],"mappings":"AAAA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;;EAIE,mCAAmC;EACnC,gCAAgC;EAChC,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oDAAoD;EACpD,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;EAKE,WAAW;EACX,eAAe;AACjB;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa,EAAE,qBAAqB;EACpC,mBAAmB,EAAE,2BAA2B;EAChD,uBAAuB,EAAE,sBAAsB;EAC/C,kBAAkB,EAAE,aAAa;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,cAAc;EACzC,qBAAqB,EAAE,eAAe;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qBAAqB,EAAE,mBAAmB;EAC1C,kBAAkB,EAAE,uBAAuB;AAC7C;;AAEA;EACE,cAAc,EAAE,eAAe;EAC/B,kBAAkB,EAAE,aAAa;EACjC,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB,EAAE,sBAAsB;AAC5C;;AAEA;EACE,cAAc,EAAE,eAAe;EAC/B,mBAAmB,EAAE,2BAA2B;EAChD,uBAAuB,EAAE,sBAAsB;EAC/C,kBAAkB,EAAE,aAAa;EACjC,kBAAkB,EAAE,sBAAsB;AAC5C;;AAEA;EACE,4BAA4B;AAC9B;;;AAGA;EACE,mBAAmB;EACnB,oDAAoD,EAAE,eAAe;EACrE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB,EAAE,UAAU;EACjC,WAAW;EACX,yBAAyB,EAAE,oBAAoB;EAC/C,yCAAyC,EAAE,gBAAgB;EAC3D,eAAe;AACjB;;AAEA;EACE,oDAAoD,EAAE,mBAAmB;EACzE,2BAA2B,EAAE,gBAAgB;EAC7C,yCAAyC,EAAE,YAAY;AACzD;;AAEA;EACE,wBAAwB,EAAE,aAAa;EACvC,wCAAwC,EAAE,mBAAmB;AAC/D;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;;AAGA;;EAEE,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;;AAGA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;;;EAGE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;;;AAGA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB,EAAE,4BAA4B;AAClD;;;;;AAKA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,gCAAgC;IAChC,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;MACI,qCAAqC;MACrC,6BAA6B;MAC7B,UAAU;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;;;IAGE,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,4BAA4B,EAAE,eAAe;EAC7C,gCAAgC,EAAE,SAAS;EAC3C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,yBAAyB,EAAE,YAAY;EACvC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa,EAAE,oCAAoC;AACrD;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB,EAAE,QAAQ;EACnC,6BAA6B,EAAE,WAAW;EAC1C,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,WAAW;EACjD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;;CAGC,iBAAiB;CACjB;EACC;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,WAAW;EACb;AACF","sourcesContent":[".p-form ol,\n.p-form  ul {\n  list-style: none;\n  list-style-type: none;\n}\n\n.p-form a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.p-form img {\n  height: auto;\n  max-width: 100%;\n  vertical-align: top;\n}\n\n.p-form table {\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 100%;\n}\n\n.p-form input,\n.p-form button,\n.p-form textarea,\n.p-form select {\n  -webkit-appearance: none !important;\n  -moz-appearance: none !important;\n  appearance: none !important;\n  border-radius: 0;\n  font-family: inherit;\n}\n\n.p-form input::-webkit-input-placeholder,\ntextarea::-webkit-input-placeholder {\n  color: #757575;\n}\n\n.p-form input::-moz-placeholder,\ntextarea::-moz-placeholder {\n  color: #757575;\n}\n\n.p-form input:-ms-input-placeholder,\ntextarea:-ms-input-placeholder {\n  color: #757575;\n}\n\n.p-form input::-ms-input-placeholder,\ntextarea::-ms-input-placeholder {\n  color: #757575;\n}\n\n.p-form input::placeholder,\ntextarea::placeholder {\n  color: #757575;\n}\n\n.p-form input[type=submit],\n.p-form button {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: none;\n  cursor: pointer;\n  outline: none;  \n  align-items: center;\n  background: #2a3d86;\n  background: linear-gradient(90deg, #2a3d86, #5a5fd9);\n  color: #fff;\n  display: flex;\n  font-size: 1.6rem;\n  font-family: serif;\n  font-weight: 700;\n  height: 5rem;\n  justify-content: center;\n  margin: 2.5rem auto 0;\n  border-radius: 2.5rem;\n  max-width: 40rem;\n  opacity: 1;\n  width: 100%;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.p-form__item:not(:first-child) {\n  margin-top: 2.5rem;\n}\n\n.p-form__head {\n  font-family: serif;\n  font-weight: 700;\n  padding-bottom: 0.5rem;\n}\n\n.p-form__body {\n  font-size: 1.2rem;\n}\n\n.p-form__body input,\n.p-form__body select {\n  background: #f5f5f5;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  box-sizing: border-box;\n  font-family: inherit;\n  font-size: 1.2rem;\n  padding: 1rem 1rem;\n}\n\n.p-form__body textarea {\n  background: #f5f5f5;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  box-sizing: border-box;\n  font-family: inherit;\n  font-size: 1.2rem;\n  padding: 1rem 1rem;\n  width: 100%;\n}\n\n.p-form__body select:disabled {\n  color: #8f8f8f;\n}\n\n.p-form__body {\n  position: relative;\n}\n\n.p-form__body input[type=text],\n.p-form__body input[type=tel],\n.p-form__body input[type=email],\n.p-form__body input[type=textarea],\n.p-form__body select {\n  width: 100%;\n  max-width: 100%;\n}\n\n\n.p-form__mb {\n  margin-bottom: 1rem;\n}\n\n.p-form__form-area {\n  position: relative;\n}\n\n.p-form__form-area--devide {\n  width: calc(50% - 0.5rem);\n}\n\n.p-form__form-area--devide:last-child {\n  margin-left: 1rem;\n}\n\n.p-form__required, .any {\n  bottom: 1.6rem;\n  color: #fff;\n  display: inline-block;\n  font-size: 1rem;\n  font-weight: 500;\n  height: 1.6rem;\n  line-height: 1;\n  line-height: 1.4rem;\n  margin-left: 1rem;\n  text-align: center;\n  width: 3.7rem;\n  background-color: #ff9b15;\n  vertical-align: middle;\n}\n\n.p-form__privacy {\n  margin-top: 5rem;\n  display: flex; /* フレックスボックスで横並びにする */\n  align-items: center; /* チェックボックスとテキストを縦方向に中央揃え */\n  justify-content: center; /* チェックボックスとテキストを左揃え */\n  text-align: center; /* テキストを左揃え */\n}\n\n.p-form__privacy-check {\n  width: 2rem;\n  height: 2rem;\n  margin-right: 1rem;\n  appearance: none;\n  border: 0.1rem solid #2a3d86;\n  border-radius: 0.2rem;\n  position: relative;\n  background-color: #ffffff;\n}\n\n.p-form__privacy-check:checked {\n  background-color: #2a3d86; /* チェック時の背景色 */\n  border-color: #2a3d86; /* チェック時の枠線の色 */\n}\n\n.p-form__privacy-check:checked::after {\n  content: '';\n  position: absolute;\n  top: 0.3rem;\n  left: 0.6rem;\n  width: 0.6rem;\n  height: 1.2rem;\n  border: solid white;\n  border-width: 0 0.2rem 0.2rem 0;\n  transform: rotate(45deg);\n}\n\n.p-form__privacy-label {\n  font-size: 1.4rem;\n  font-family: serif;\n  cursor: pointer;\n  display: inline-block; /* ラベルをインラインブロックに */\n  margin-right: 1rem; /* テキストとリンクの間にスペースを追加 */\n}\n\n.p-form__privacy-link {\n  display: block; /* リンクを別の行に表示 */\n  text-align: center; /* リンクを中央揃え */\n  color: blue !important;\n  text-decoration: underline;\n  margin-top: 0.5rem; /* ラベルとリンクの間にスペースを追加 */\n}\n\n.p-form__privacy-error {\n  display: block; /* リンクを別の行に表示 */\n  align-items: center; /* チェックボックスとテキストを縦方向に中央揃え */\n  justify-content: center; /* チェックボックスとテキストを左揃え */\n  text-align: center; /* リンクを中央揃え */\n  margin-top: 0.5rem; /* ラベルとリンクの間にスペースを追加 */\n}\n\n.p-form__notice {\n  font-size: 1.4rem !important;\n}\n\n\n.p-form__send {\n  align-items: center;\n  background: linear-gradient(90deg, #2a3d86, #5a5fd9); /* グラデーションを適用 */\n  color: #fff;\n  display: flex;\n  font-size: 1.8rem;\n  font-weight: 700;\n  height: 5rem;\n  justify-content: center;\n  margin: 3rem auto 0;\n  max-width: 40rem;\n  border: none;\n  border-radius: 2.5rem; /* 丸みを追加 */\n  width: 100%;\n  transition: all 0.3s ease; /* スムーズなトランジションを追加 */\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* ボックスシャドウを追加 */\n  cursor: pointer;\n}\n\n.p-form__send:hover {\n  background: linear-gradient(90deg, #5a5fd9, #2a3d86); /* ホバー時のグラデーション反転 */\n  transform: translateY(-3px); /* ホバー時に少し浮かせる */\n  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2); /* シャドウを強調 */\n}\n\n.p-form__send:active {\n  transform: translateY(0); /* クリック時に戻す */\n  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1); /* クリック時のシャドウを弱める */\n}\n\n\n.p-form__send.is_checked {\n  opacity: 1;\n}\n\n.p-form__two-columns {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: nowrap;\n}\n\n.p-form__input-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n\n.p-form__two-columns input,\n.p-form__two-columns select {\n  width: 100%;\n}\n.p-form__margin-bottom {\n  margin-bottom: 0.5rem;\n}\n\n.p-form__subtext {\n  font-size: 1rem;\n  color: #757575;\n  margin-top: 0.2rem;\n}\n\n/* 警告メッセージ表示用 */\n.error.warning {\n  display: block;\n  color: #FB3640;\n  font-size: 1.2rem;\n  margin-top: 0.5rem;\n}\n\n/** alert **/\n.alert {\n  font-size: 1rem;\n  color: #FB3640;\n}\n\n.notfilled {\n  font-size: 1.2rem;\n  color: #fff;\n  background-color: #FB3640;\n  text-align: center;\n}\n\n\n.notfilled.invalid {\n  background-color: #FB3640;\n  color: white;\n}\n\n.recaptcha-error {\n  color: #FB3640;\n  font-size: 1.2rem;\n  text-align: center;\n}\n\n/* 未記入項目がある場合のエラースタイル */\n.invalid input,\n.invalid select,\n.invalid textarea {\n  border: 0.1rem solid #FB3640;\n  background-color: #ffe1e1;\n}\n\n.error {\n  color: #FB3640;\n  font-size: 1.2rem;\n  display: none;\n}\n\n\n.error.invalid {\n  display: block;\n  color: #FB3640;\n  font-size: 1.2rem;\n  margin-top: 0.5rem; /* エラーメッセージと他の要素の間にスペースを追加 */\n}\n\n\n\n\n@media only screen and (min-width: 768px) {\n  .p-form__head {\n    font-size: 1.2rem;\n  }\n  .p-form__item {\n    border-top: 0.1rem solid #e5e5e5;\n    display: flex;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding: 0.5rem 0;\n  }\n\n  .p-form__item--bottom {\n    display: flex;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding: 0 0 1rem 0;\n  }\n\n  .p-form__item:not(:first-child) {\n    margin-top: 0;\n  }\n\n  .p-form__head {\n      -webkit-transform: translateY(0.5rem);\n      transform: translateY(0.5rem);\n      width: 30%;\n  }\n  \n  .p-form__item:not(:first-child) {\n    margin-top: 0;\n  }\n  \n  .p-form__body {\n    width: 70%;\n  }\n  \n  .p-form__body input,\n  .p-form__body textarea,\n  .p-form__body select {\n    font-size: 1.2rem;\n    padding-bottom: 1.8rem;\n    padding-top: 1.8rem;\n  }\n  \n  .p-form__form-area--devide {\n    width: calc(50% - 1rem);\n  }\n  \n  .p-form__form-area--devide:last-child {\n    margin-left: 2rem;\n  }\n  \n  .p-form__required {\n    font-size: 1.2rem;\n    font-family: sans-serif;\n  }\n  \n  .p-form__send {\n    font-size: 1.6rem;\n    height: 7.4rem;\n    margin-top: 5rem;\n  }\n}\n.g-recaptcha {\n  margin-right: auto;\n  margin-left: auto;\n  text-align: center;\n  width: 30rem;\n  margin-top: 2rem;\n}\n\n.loader {\n  border: 0.6rem solid #f3f3f3; /* Light grey */\n  border-top: 0.6rem solid #2a3d86; /* Blue */\n  border-radius: 50%;\n  width: 5rem;\n  height: 5rem;\n  animation: spin 1s linear infinite;\n}\n\n.p-form__send.is-submitting {\n  background-color: #d3d3d3; /* 処理中の背景色 */\n  cursor: not-allowed;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n#loadingIndicator {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1000; /* Ensure it's above other content */\n}\n\n/* ローディングスピナー */\n.loading-spinner {\n  width: 20px;\n  height: 20px;\n  border: 3px solid #f3f3f3; /* 背景色 */\n  border-top: 3px solid #3498db; /* スピナーの色 */\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  display: inline-block;\n}\n\n/* スピナーのアニメーション */\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* ボタンが処理中のスタイル */\n.p-form__send.is-submitting {\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\n/* 画面全体を覆うオーバーレイ */\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5); /* 半透明の背景 */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n\n /* モバイル用メディアクエリ */\n @media (max-width: 767px) {\n  .p-form__head {\n    font-size: 1.2rem;\n  }\n\n  .p-form__item:not(:first-child) {\n    margin-top: 1rem;\n  }\n  .p-form__privacy {\n    margin-top: 2rem;\n  }\n\n  .p-form__two-columns {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
